import React, {
  ForwardedRef,
  forwardRef,
  InputHTMLAttributes,
} from 'react';
import classNames from 'classnames';

import ErrorMessage from 'common/components/ErrorMessage';

import styles from './styles.module.scss';

export interface ITextareaProps extends InputHTMLAttributes<HTMLTextAreaElement> {
  label?: string,
  error?: string,
  required?: boolean,
}

const Textarea = forwardRef(({
  name,
  label,
  error,
  required,
  disabled,
  className,
  ...props
}: ITextareaProps, ref: ForwardedRef<HTMLTextAreaElement>) => (
  <div
    className={classNames(
      styles.wrapper,
      'common-components-Textarea__wrapper',
      className,
      {
        [styles.disabled]: disabled,
        'common-components-Textarea__wrapper--disabled': disabled,
      },
    )}
  >
    {label && (
      <div className={classNames(
        styles.label,
        'common-components-Textarea__label',
      )}
      >
        {label}
        {required && <span className={styles.required}>*</span>}
      </div>
    )}
    <textarea
      {...props}
      ref={ref}
      className={classNames(
        styles.input,
        'common-components-Textarea__input',
        {
          [styles.error]: error,
        },
      )}
      name={name}
      disabled={disabled}
    />
    {error && <ErrorMessage text={error} />}
  </div>
));

export default Textarea;
